import React, { Component, Fragment } from "react";
import {
  Button,
  FormGroup,
  FormControl,
  ButtonGroup,
} from "react-bootstrap";
import { ReactTabulator } from "react-tabulator";
import Header from "../header";
import CreateNewUserSvg from "./createnewusersvg";
import CreateUserPopup from "./createuserpopup";
import UpdateGroupsPopup from "./updateGroups";
import UpdateReposPopup from "./updateRepos";
import {
  listGroupsForUser2,
  listReposForUser,
  getUsersByClientId,
  deleteUser,
  getClientDetails,
  updateClientMfaRequirement,
} from "../../libs/API";
import "./manageusers.css";
import {
  DeleteFileSvg,
  RedactionReasonSvg,
  DownloadIndexSvg,
  DocumentManagementSvg,
} from "../Svg/allsvg";
import Popup from "reactjs-popup";
import { role } from "../enum";
import UserProfilePopup from "./userProfilePopup";
import RedactionReasonPopup from "./redactionReasonPopup";
import UndeleteUsers from "./undeleteUsers";
import DocumentManagementSettingsPopup from "./DocumentManagementSettingsPopup";

class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateUserPopup: false,
      showUpdateGroupsPopup: false,
      showUpdateReposPopup: false,
      deleteUserPopupOpen: false,
      showRedactionPopup: false,
      users: [],
      email: "",
      username: "",
      groups: [],
      repos: [],
      client: "",
      clientId: this.props.props.clientId,
      clientData: null,
      selectedClientId: this.props.props.clientId,
      hasManageClientsUserRole: false,
      selectedClientRequireMfa: false,
      isUpdatingMfa: false, // Flag to track MFA update in progress
      showProfilePopup: false,
      clickedUserEmail: "",
      activeTab: "manage",
      deleteValidationError: "",
      // TODO: Backend load will be connected later.
      showDocumentManagementPopup: false,
      documentManagementEntries: [
        {
          description: "",
          recordSeries: "",
          retentionPeriod: "",
        },
      ],
    };
    this.ref = null;
    this.handleEditGroups = this.handleEditGroups.bind(this);
    this.hideUpdateGroups = this.hideUpdateGroups.bind(this);
    this.showUpdateGroups = this.showUpdateGroups.bind(this);
    this.hideUpdateRepos = this.hideUpdateRepos.bind(this);
    this.showUpdateRepos = this.showUpdateRepos.bind(this);
    this.toggleMfaRequirement = this.toggleMfaRequirement.bind(this);
  }

  async componentDidMount() {
    await this.populateClient();
    if (this.state.selectedClientId) {
      // Create a synthetic event object if needed
      const event = {
        preventDefault: () => {},
        target: { value: this.state.selectedClientId },
      };
      this.onClientChange(event);
    }
  }

  openUserProfilePopup = (e, cell) => {
    e.preventDefault();
    this.setState({
      showProfilePopup: true,
      clickedUserEmail: cell.getRow().getData().email,
    });
  };

  openRedactionPopup = () => this.setState({ showRedactionPopup: true });
  closeRedactionPopup = () => this.setState({ showRedactionPopup: false });

  handleOpenRecordManagementSettings = () => {
    if (!this.state.selectedClientId) {
      console.warn("Record Management Settings requires selectedClientId.");
      return;
    }

    this.setState({
      showDocumentManagementPopup: true,
    });
  };

  handleDocumentManagementSave = (entries, selectedClientId) => {
    this.setState({
      documentManagementEntries: entries,
      documentManagementClientId: selectedClientId,
      showDocumentManagementPopup: false,
    });

    // TODO: Backend save will be connected later with selectedClientId.
  };

  handleDocumentManagementCancel = () => {
    this.setState({
      showDocumentManagementPopup: false,
    });
  };

  renderClientSettingsControls() {
    const { selectedClientId } = this.state;

    if (!selectedClientId) {
      return null;
    }

    return (
      <Fragment>
        <Button
          bsSize="xsmall"
          bsClass="btn btn-outline-secondary record-management-settings-button"
          onClick={this.handleOpenRecordManagementSettings}
          title="Record Management Settings"
        >
          <span className="document-management-icon">
            <DocumentManagementSvg />
          </span>
          <span className="document-management-text">
            Record Management Settings
          </span>
        </Button>
      </Fragment>
    );
  }

  closeUserProfilePopup = () => {
    this.setState({ showProfilePopup: false });
  };

  async populateClient() {
    try {
      var hasManageClientsUserRole = this.props.props.groups.includes(
        role.documentSync_ManageClients,
      );

      if (
        this.state.clientId &&
        this.state.clientId > 0 &&
        !hasManageClientsUserRole
      ) {
        // For a single client, we need to fetch its MFA status
        const clientData = await getClientDetails();
        const currentClient = clientData.find(
          (client) => client.clientId === parseInt(this.state.clientId),
        );

        if (currentClient) {
          this.setState({
            selectedClientRequireMfa: currentClient.requireMfa,
            selectedClientId: this.state.clientId,
          });
        }

        await this.populateUsers(this.state.clientId);
      } else {
        const data = await getClientDetails(); // Fetch client details
        this.setState({
          clientData: data,
          hasManageClientsUserRole,
        }); // Update state with client data
      }
    } catch (error) {
      console.error("Error populating client details:", error); // Handle errors
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedClientId !== this.state.selectedClientId) {
      this.populateUsers(this.state.selectedClientId);
    }
  }

  async populateUsers(clientId) {
    await getUsersByClientId(clientId).then(async (data) => {
      this.setState({ users: data }, () => {
        if (this.ref && this.ref.table) {
          this.ref.table.setData(data);
        }
      });
    });
  }

  async loadGroups(user) {
    const { username } = user;
    listGroupsForUser2(username).then((data) => {
      const groups = data;
      if (!groups.includes("DocumentSync")) {
        this.ref.table.deleteRow(username);
      } else {
        const rowData = this.ref.table.getRow(username).getData();
        rowData.groups = groups;
        this.ref.table.updateOrAddData([rowData]);
      }
    });
  }

  handleChildUnmount = () => {
    this.setState({ showCreateUserPopup: false });
  };

  handleNewRowInUserList = (addNewRow) => {
    let userList = this.state.users;
    userList.unshift(addNewRow);
    this.setState({ users: userList });
    this.ref.table.addRow(addNewRow, true);
  };

  handleCreateUser = () => {
    if (this.state.selectedClientId) {
      this.setState({ showCreateUserPopup: true });
    } else {
      alert("Please select a client from dropdown");
    }
  };

  showUpdateGroups() {
    this.setState({ showUpdateGroupsPopup: true });
  }

  async hideUpdateGroups() {
    this.setState({ showUpdateGroupsPopup: false });
  }

  updateGroups = async (userId, roles) => {
    const rowData = await this.ref.table.getRow(userId).getData();
    rowData.roles = roles;
    this.ref.table.updateOrAddData([rowData]);
  };

  showUpdateRepos() {
    this.setState({ showUpdateReposPopup: true });
  }

  async hideUpdateRepos() {
    this.setState({ showUpdateReposPopup: false });
  }

  groupFormatter(cell) {
    const groupArray = cell._cell.value;
    // Filter and map to display names of roles that have relevant DS roles
    if (groupArray) {
      const formattedNames = groupArray
        .map((role) => role.roleName) // Extract roleName from each role
        .filter((roleName) => roleName.startsWith("DocumentSync_")) // Only keep DocumentSync roles
        .map((roleName) => {
          const role = roleName.split("_")[1]; // Extract the part after "DocumentSync_"
          if (role === "OCR" || role === "PII") {
            return role; // Return OCR or PII directly
          } else if (role === "RestrictAccessByIP") {
            return "Restrict Access By IP"; // Special case for RestrictAccessByIP
          } else {
            // Add space between camelCase words
            return role.replace(/([a-z])([A-Z])/g, "$1 $2");
          }
        })
        .join(", ");

      return formattedNames || "No Roles"; // Return formatted names or default text
    }
  }

  handleEditGroups(e, row) {
    e.preventDefault();
    const rowData = row._row.data;
    this.setState(
      {
        email: rowData.email,
        groups: rowData.roles,
        username: rowData.userId,
      },
      () => {
        this.showUpdateGroups();
      },
    );
  }

  async updateRepos(e, row) {
    e.preventDefault();
    const { email, userId } = row._row.data;
    let data = await listReposForUser(email);
    // coalesce null → []
    const userRepos = data || [];
    // update the row in the table
    const rowData = this.ref.table.getRow(userId).getData();
    rowData.repos = userRepos;
    this.ref.table.updateOrAddData([rowData]);

    // set state so UpdateReposPopup gets a non-null array
    this.setState(
      {
        email,
        repos: userRepos,
        username: userId,
      },
      this.showUpdateRepos,
    );
  }

  renderRedactionReasonPopup() {
    return (
      <Fragment>
        {this.state.showRedactionPopup && (
          <RedactionReasonPopup
            show={this.state.showRedactionPopup}
            onHide={this.closeRedactionPopup}
            clientId={this.state.selectedClientId}
            // optionally pass clientId or user context
          />
        )}
      </Fragment>
    );
  }

  renderDeleteUserPopup() {
    return (
      <Fragment>
        <Popup
          contentStyle={{
            width: "32%",
            borderRadius: "15px",
            padding: "35px",
          }}
          open={this.state.deleteUserPopupOpen}
          modal
          closeOnDocumentClick={false}
          onClose={this.closeopup}
        >
          <div>
            {/* eslint-disable-next-line */}
            <a className="close" onClick={this.closePopup}>
              &times;
            </a>
            <div>
              <h5>Delete User</h5>
              <div>
                <FormGroup>
                  Are you sure you want to delete the user(s)
                </FormGroup>
                {this.state.deleteValidationError && (
                  <FormGroup className="delete-user-error">
                    {this.state.deleteValidationError}
                  </FormGroup>
                )}
                <FormGroup>
                  <Button
                    bsSize="small"
                    bsClass="btn btn-outline-secondary"
                    onClick={this.handleDeleteUsers}
                  >
                    Yes
                  </Button>
                </FormGroup>
              </div>
            </div>
          </div>
        </Popup>
      </Fragment>
    );
  }

  openDeleteUserPopup = (e) => {
    e.preventDefault();
    const rows = this.ref.table.getSelectedData();
    if (rows.length >= 1) {
      this.setState({
        deleteUserPopupOpen: true,
        deleteValidationError: "",
      });
    }
  };

  handleDeleteUsers = (e) => {
    e.preventDefault();
    const rows = this.ref.table.getSelectedData(); // Get selected rows from the table
    if (rows.length >= 1) {
      const protectedDomains = new Set([
        "documentsync.com",
        "foveonics.com",
        "foveonicsimaging.com",
      ]);

      const getNormalizedEmail = (row) => {
        const candidates = [
          row.email,
          row.userEmail,
          row.username,
          row.userName,
          row.userId,
        ];

        for (let i = 0; i < candidates.length; i++) {
          const value = String(candidates[i] || "")
            .toLowerCase()
            .replace(/\s+/g, "");
          if (value.includes("@")) {
            return value;
          }
        }
        return "";
      };

      const blockedRows = rows.filter((row) => {
        const email = getNormalizedEmail(row);
        if (!email) return false;
        const atIndex = email.lastIndexOf("@");
        if (atIndex < 0) return false;
        const domain = email.slice(atIndex + 1).replace(/[^a-z0-9.-]/g, "");
        return protectedDomains.has(domain);
      });

      const hasProtectedEmail = blockedRows.length > 0;

      if (hasProtectedEmail) {
        this.setState({
          deleteValidationError:
            "@documentsync.com, @foveonics.com, @foveonicsimaging.com - Cannot delete Foveonics admin user. Please contact Foveonics support.",
        });
        return;
      }

      let users = [];
      for (let i = 0; i < rows.length; i++) {
        let Params = {
          username: rows[i].userId,
          userEmail: rows[i].email,
          groups: rows[i].roles.map((group) => group.roleName),
        };
        users.push(Params);
      }

      // Call deleteUser API
      deleteUser(users).then((data) => {
        if (data.status === 200) {
          let userList = this.state.users;

          // Filter out users that were deleted from the userList
          let filteredList = userList.filter((x) => {
            return !users.some((y) => y.userEmail === x.email);
          });

          // Update the state first to trigger a re-render
          this.setState({ users: filteredList }, () => {
            // After the state is updated, reflect changes in the table
            this.ref.table.replaceData(filteredList); // use replaceData to update the entire table
            this.closePopup(); // Close popup after the operation
          });
        }
      });
    }
  };

  closePopup = () => {
    this.setState({
      deleteUserPopupOpen: false,
      deleteValidationError: "",
    });
  };

  // Add this method to your ManageUsers component

  normalizeRoleName = (roleName) => {
    if (!roleName || !roleName.startsWith("DocumentSync_")) {
      return "";
    }
    const role = roleName.split("_")[1];
    if (role === "OCR" || role === "PII") return role;
    if (role === "RestrictAccessByIP") return "Restrict Access By IP";
    return role.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  formatRolesForExport = (roles) => {
    if (!Array.isArray(roles)) return "";
    return roles
      .map((x) => this.normalizeRoleName(x.roleName))
      .filter(Boolean)
      .join(", ");
  };

  formatReposForExport = (repos) => {
    if (!Array.isArray(repos)) return "";
    return repos
      .map((repo) => {
        if (typeof repo === "string") return repo;
        if (repo.folderName && repo.owner) {
          return `${repo.folderName} / ${repo.owner}`;
        }
        return (
          repo.folderName ||
          repo.owner ||
          repo.repoName ||
          repo.name ||
          repo.repositoryName ||
          ""
        );
      })
      .filter(Boolean)
      .join(", ");
  };

  escapeCsvValue = (value) => {
    const text = String(value ?? "");
    if (text.includes('"') || text.includes("|") || text.includes("\n")) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  };

  handleDownloadIndexCsv = async (e) => {
    e.preventDefault();
    if (!this.state.selectedClientId) {
      alert("Please select a client");
      return;
    }

    const rows = this.ref && this.ref.table ? this.ref.table.getData() : [];
    if (!rows || rows.length === 0) {
      alert("No users available to download.");
      return;
    }

    try {
      const rowsWithRepos = await Promise.all(
        rows.map(async (row) => {
          const repos = await listReposForUser(row.email).catch(() => []);
          return { ...row, repos: repos || [] };
        }),
      );

      const headers = ["Email", "Roles", "Repos"];
      const body = rowsWithRepos.map((row) => [
        this.escapeCsvValue(row.email || ""),
        this.escapeCsvValue(this.formatRolesForExport(row.roles)),
        this.escapeCsvValue(this.formatReposForExport(row.repos)),
      ]);

      const csv = [headers.join("|"), ...body.map((x) => x.join("|"))].join(
        "\n",
      );
      const blob = new Blob([csv], {
        type: "text/plain;charset=utf-8;",
      });
      const link = document.createElement("a");
      const clientName =
        (this.state.clientData || []).find(
          (c) =>
            c.clientId.toString() === this.state.selectedClientId.toString(),
        )?.clientName || "Users";
      const fileName = `${clientName}_UserIndexData.txt`;
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Failed to download user index data:", error);
      alert("Failed to download user index data. Please try again.");
    }
  };

  toggleMfaRequirement = async () => {
    const { selectedClientId, selectedClientRequireMfa } = this.state;

    if (!selectedClientId) return;

    try {
      // Show loading state
      this.setState({ isUpdatingMfa: true });

      // Call API to update MFA requirement
      const newMfaStatus = !selectedClientRequireMfa;
      await updateClientMfaRequirement(selectedClientId, newMfaStatus);

      // Update local state
      this.setState({
        selectedClientRequireMfa: newMfaStatus,
        isUpdatingMfa: false,
      });

      // Update clientData array with new MFA status
      if (this.state.clientData) {
        const updatedClientData = this.state.clientData.map((client) => {
          if (client.clientId.toString() === selectedClientId.toString()) {
            return { ...client, requireMfa: newMfaStatus };
          }
          return client;
        });

        this.setState({ clientData: updatedClientData });
      }

      // Show success notification
      alert(
        `MFA requirement ${
          newMfaStatus ? "enabled" : "disabled"
        } for this client`,
      );
    } catch (error) {
      console.error("Failed to toggle MFA requirement:", error);
      this.setState({ isUpdatingMfa: false });
      alert("Failed to update MFA requirement. Please try again.");
    }
  };

  onClientChange = async (event) => {
    event.preventDefault();
    const selectedClientId = event.target.value;
    if (selectedClientId) {
      // Find the selected client in the clientData
      const selectedClient =
        this.state.clientData && this.state.clientData.length
          ? this.state.clientData.find(
              (client) => client.clientId.toString() === selectedClientId,
            )
          : null;
      // Update the state with the selected client ID and its MFA requirement
      this.setState(
        {
          selectedClientId,
          selectedClientRequireMfa: selectedClient
            ? selectedClient.requireMfa
            : false,
        },
        async () => {
          try {
            // Call populateUsers after the state has been updated
            await this.populateUsers(selectedClientId);
          } catch (error) {
            console.error("Failed to load users:", error);
          }
        },
      );
    } else {
      this.setState({
        selectedClientId: null,
        selectedClientRequireMfa: false,
      });
      if (this.ref && this.ref.table) {
        this.ref.table.setData(null);
      }
    }
  };

  render() {
    const {
      showCreateUserPopup,
      showUpdateGroupsPopup,
      showUpdateReposPopup,
      email,
      username,
      groups,
      repos,
      clientData,
      selectedClientId,
      hasManageClientsUserRole,
      selectedClientRequireMfa,
      isUpdatingMfa,
      showProfilePopup,
      clickedUserEmail,
      activeTab,
      showDocumentManagementPopup,
      documentManagementEntries,
    } = this.state;
    const { loggedInUser } = this.props.props;

    return (
      <div className="manageusers-main">
        <Header props={this.props.props} history={this.props.history} />

        {/* ===== Tab Buttons ===== */}
        <div className="tab-buttons-container">
          <ButtonGroup>
            <Button
              className={activeTab === "manage" ? "active-tab" : ""}
              onClick={() => {
                if (activeTab !== "manage") {
                  this.setState({ activeTab: "manage" }, () => {
                    // re-load your users whenever we switch back
                    if (selectedClientId) {
                      this.populateUsers(selectedClientId);
                    }
                  });
                }
              }}
            >
              Manage Users
            </Button>
            <Button
              className={activeTab === "undelete" ? "active-tab" : ""}
              onClick={() => this.setState({ activeTab: "undelete" })}
            >
              Undelete Users
            </Button>
          </ButtonGroup>
        </div>

        {/* ===== Manage Users Panel ===== */}
        {activeTab === "manage" && (
          <div className="manageusers-content">
            <h4>Manage Users</h4>

            <div className="client-controls">
              {(!selectedClientId ||
                selectedClientId <= 0 ||
                hasManageClientsUserRole) && (
                <div className="client-selector-container">
                  <FormControl
                    componentClass="select"
                    className="client-select"
                    onChange={this.onClientChange}
                    value={selectedClientId || ""}
                  >
                    <option value="">Select Client</option>
                    {clientData?.map((c) => (
                      <option key={c.clientId} value={c.clientId}>
                        {c.clientName}
                      </option>
                    ))}
                  </FormControl>

                  {selectedClientId && (
                    <div
                      className={`mfa-indicator ${
                        selectedClientRequireMfa
                          ? "mfa-required"
                          : "mfa-not-required"
                      } ${isUpdatingMfa ? "mfa-updating" : ""}`}
                      onClick={this.toggleMfaRequirement}
                      title="Click to toggle MFA requirement"
                    >
                      <span className="mfa-icon">
                        {isUpdatingMfa
                          ? "⟳"
                          : selectedClientRequireMfa
                            ? "🔒"
                            : "🔓"}
                      </span>
                      <span className="mfa-text">
                        {isUpdatingMfa
                          ? "Updating..."
                          : selectedClientRequireMfa
                            ? "MFA Required"
                            : "MFA Not Required"}
                      </span>
                    </div>
                  )}

                  <Button
                    title="Manage Redaction Reasons"
                    bsSize="xsmall"
                    bsClass="btn btn-outline-secondary"
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      if (selectedClientId) this.openRedactionPopup();
                      else alert("Please select a client");
                    }}
                  >
                    <RedactionReasonSvg />
                  </Button>
                </div>
              )}

              {this.renderClientSettingsControls()}

              <Button
                title="Delete User"
                bsSize="xsmall"
                bsClass="btn btn-outline-secondary"
                className="Delete-UserButton"
                onClick={this.openDeleteUserPopup}
              >
                <DeleteFileSvg />
              </Button>

              <Button
                title="Download Index Data of Users"
                bsSize="xsmall"
                bsClass="btn btn-outline-secondary"
                className="Delete-UserButton"
                onClick={this.handleDownloadIndexCsv}
              >
                <DownloadIndexSvg />
              </Button>

              <Button
                title="Create a New User"
                bsSize="xsmall"
                bsClass="btn btn-outline-secondary"
                className="Add-UserButton"
                onClick={this.handleCreateUser}
              >
                <CreateNewUserSvg />
              </Button>
            </div>

            <div id="listUsers">
              <div style={{ width: "100%", overflowX: "auto" }}>
                <ReactTabulator
                  ref={(ref) => (this.ref = ref)}
                  index="userId"
                  columns={[
                    {
                      formatter: "rowSelection",
                      titleFormatter: "rowSelection",
                      titleFormatterParams: { rowRange: "visible" },
                      width: 20,
                      headerSort: false,
                      cellClick: (e, cell) => cell.getRow().toggleSelect(),
                    },
                    { field: "email", title: "Email", headerFilter: true },
                    {
                      field: "roles",
                      title: "Roles",
                      formatter: this.groupFormatter,
                      overflowX: "auto",
                      maxWidth: 920,
                    },
                    {
                      formatter: () => "<button>Edit Roles</button>",
                      cellClick: (e, cell) => {
                        this.handleEditGroups(e, cell.getRow());
                      },
                    },
                    {
                      formatter: () => "<button>Edit Repos</button>",
                      cellClick: async (e, cell) => {
                        await this.updateRepos(e, cell.getRow());
                      },
                    },
                    {
                      formatter: () => "<button>Edit User Profile</button>",
                      cellClick: (e, cell) => {
                        this.openUserProfilePopup(e, cell);
                      },
                    },
                  ]}
                  data={[]}
                  options={{
                    layout: "fitData",
                    pagination: "local",
                    paginationSize: 10,
                    paginationSizeSelector: [10, 20, 50, 100],
                    placeholder: "Loading...",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* ===== Undelete Users Panel ===== */}
        {activeTab === "undelete" && (
          <div
            className="undelete-users-content"
            style={{ padding: "1rem", margin: "0 2%" }}
          >
            <div className="client-controls">
              {/* client dropdown */}
              {(selectedClientId <= 0 || hasManageClientsUserRole) && (
                <div className="client-selector-container">
                  <FormControl
                    componentClass="select"
                    className="client-select"
                    onChange={this.onClientChange}
                    value={selectedClientId || ""}
                  >
                    <option value="">Select Client</option>
                    {clientData.map((c) => (
                      <option key={c.clientId} value={c.clientId}>
                        {c.clientName}
                      </option>
                    ))}
                  </FormControl>
                </div>
              )}
            </div>
            {/* the table itself */}
            {selectedClientId > 0 ? (
              <UndeleteUsers clientId={selectedClientId} />
            ) : (
              <p>Please select a client to load deleted users.</p>
            )}
          </div>
        )}

        {/* ===== Popups & Modals (unchanged) ===== */}
        {showCreateUserPopup && (
          <CreateUserPopup
            props={{ showCreateUserPopup }}
            unmountMe={this.handleChildUnmount}
            clientId={selectedClientId}
            loggedInUser={loggedInUser}
            handleNewRowInUserList={this.handleNewRowInUserList}
          />
        )}
        {showUpdateGroupsPopup && (
          <UpdateGroupsPopup
            props={{
              showUpdateGroupsPopup,
              email,
              username,
              groups,
              client: selectedClientId,
              selectedClientId,
              loggedInUser,
            }}
            unmountMe={this.hideUpdateGroups}
            updateGroups={this.updateGroups}
          />
        )}
        {showUpdateReposPopup && (
          <UpdateReposPopup
            props={{
              showUpdateReposPopup,
              email,
              username,
              repos,
              selectedClientId,
            }}
            unmountMe={this.hideUpdateRepos}
          />
        )}
        {this.renderDeleteUserPopup()}
        {showProfilePopup && (
          <UserProfilePopup
            show={showProfilePopup}
            onHide={this.closeUserProfilePopup}
            clickedUserEmail={clickedUserEmail}
          />
        )}
        {this.renderRedactionReasonPopup()}
        {showDocumentManagementPopup && (
          <DocumentManagementSettingsPopup
            show={showDocumentManagementPopup}
            entries={documentManagementEntries}
            selectedClientId={selectedClientId}
            onSave={this.handleDocumentManagementSave}
            onCancel={this.handleDocumentManagementCancel}
          />
        )}
      </div>
    );
  }
}
export default ManageUsers;
